import React, { useEffect } from "react";
import { Box, Typography, Paper, Link } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getBilling } from "../../Redux/Slice/BillingSlice";

const BillingHistoryPage = () => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.billing);
  const bills = items?.data || [];

  useEffect(() => {
    dispatch(getBilling());
  }, [dispatch]);

  return (
    <Box sx={{ padding: "2rem" }}>
      <Typography variant="h5" gutterBottom>
        Billing History
      </Typography>
      <Typography variant="body1" color="text.secondary">
        View your billing and payment history.
      </Typography>

      <Box mt={3}>
        {bills.length === 0 ? (
          <Typography>No billing records available.</Typography>
        ) : (
          bills.map((bill) => (
            <Paper key={bill.billId} sx={{ p: 2, mb: 2 }}>
              <Typography fontWeight={600}>
                Invoice #: {bill.invoiceNo}
              </Typography>
              <Typography>Date: {bill.invoiceDate}</Typography>
              <Typography>Name: {bill.patientName}</Typography>
              <Typography>Doctor: {bill.doctorName}</Typography>
              <Typography>Specialty: {bill.specialityName}</Typography>
              <Typography>Amount: ₹{bill.billAmount.toFixed(2)}</Typography>
              <Typography>Status: {bill.billStatus}</Typography>
              {bill.billPdfPath && (
                <Link
                  href={bill.billPdfPath}
                  target="_blank"
                  rel="noopener"
                  underline="hover"
                >
                  View PDF
                </Link>
              )}
            </Paper>
          ))
        )}
      </Box>
    </Box>
  );
};

export default BillingHistoryPage;
